import * as React from 'react';
import {hideVisually} from 'polished';
import {styled, mq} from '../../../utils';
import {rgba, padding} from 'polished';
import {Sider as BaseSider} from '../../Layout';
import Flex from '../../Flex';
import {PillButton} from '../../Button';
import logo from '../../../images/logo-0.svg';
import sideBg from '../../../images/auth-sidebar-bg.png';

const Root = styled(BaseSider)(({theme}) => {
  const sideBgColor = rgba(theme.color.primary, 0.9);
  return {
    backgroundColor: sideBgColor,
    background: `linear-gradient(to bottom, ${sideBgColor}, ${sideBgColor}), url(${sideBg})`,
    backgroundPosition: 'right bottom',
    height: '100vh',
    flexBasis: '40%',
    overflow: 'auto',
    ...padding(50, 80),
    [mq('phone')]: hideVisually(),
    [mq('tablet')]: hideVisually(),
    [mq('desktop')]: {
      ...padding(70, 100)
    }
  };
});

const Logo = styled('img')({
  width: 250,
  height: 47
});

const LeadTitle = styled('h1')(({theme}) => ({
  fontFamily: theme.fontFamily.base,
  color: '#fff',
  fontSize: 30,
  fontWeight: 'bold',
  lineHeight: 55 / 36,
  marginBottom: 35,
  [mq('desktop')]: {
    fontSize: 36,
    marginBottom: 65
  }
}));

const LeadParagraph = styled('p')(({theme}) => ({
  fontFamily: theme.fontFamily.base,
  fontSize: 16,
  color: rgba('#fff', 0.55),
  lineHeight: 34 / 16,
  marginBottom: 35,
  [mq('desktop')]: {
    marginBottom: 45
  }
}));

export default class Sider extends React.Component<{}, {}> {
  public render() {
    return (
      <Root>
        <Flex direction="column" justify="space-between" style={{height: '100%'}}>
          <Logo src={logo} />

          <div>
            <LeadTitle>
              You're a great host and deserve a break now. Let Cohost Club be your trusted assistant.
            </LeadTitle>

            <LeadParagraph>
              Cohost Club helps Airbnb hosts reply to messages, respond to inquiries and filter bad guests, allowing
              hosts to take a break from managing Airbnb rentals. Get more bookings and your time back to enjoy life as
              a host.
            </LeadParagraph>

            <LeadParagraph>Hosting has never been easier.</LeadParagraph>
          </div>

          <div style={{textAlign: 'center', flexBasis: '15%'}}>
            <PillButton variant="inverse" large={true}>
              Learn more
            </PillButton>
          </div>
        </Flex>
      </Root>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/AuthLayout/Sider/Sider.tsx